import { createConsumer, type Consumer } from '@rails/actioncable'

// One WebSocket for the whole tab.
//
// Calling createConsumer() inside a useEffect opens a brand new socket per
// effect, and React StrictMode runs every effect twice in development, so two
// live-update effects turned into four simultaneous /cable handshakes on every
// page load. Each handshake is a full Rails request that touches the session,
// which is how a burst of reconnects used to knock the CSRF token out of the
// session (see ApplicationCable::Connection#connect).
//
// ActionCable multiplexes any number of subscriptions over a single consumer,
// so share one. Unsubscribe on unmount; never disconnect() the shared consumer,
// that would tear the socket out from under every other subscriber.
let consumer: Consumer | null = null

export function cableConsumer(): Consumer {
  consumer ||= createConsumer()
  return consumer
}
